export const POST_NOTIFICATION_LIST_URL = "notification/getNotifications";
export const POST_INSERT_ANNOUNCEMENT_URL = "notification/insUpdHrAnnouncement";
export const POST_DELETE_NOTIFICATION_URL = "notification/delHrNotificaton";
export const POST_UPDATE_HR_NOTIFICATION_STATUS_URL =
  "notification/getUpdHrNotifications";
export const POST_UPLOAD_NOTIFICATION_URL = "notification/uploadDoc";
export const POST_HR_ANNOUNCEMENT_LIST_URL =
  "notification/insUpdHrAnnouncement";
export const GET_ANNC_TYPE_URL = "notification/getAnncType";
